import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const azTranslations: PluginDefaultTranslationsObject = {
  'plugin-multi-tenant': {
    'assign-tenant-button-label': 'Kirayəçiyə təyin et',
    'assign-tenant-modal-title': '"{{title}}" təyin edin',
    'field-assignedTenant-label': 'Təyin edilmiş İcarəçi',
    'nav-tenantSelector-label': 'Kirayəçi',
  },
}

export const az: PluginLanguage = {
  dateFNSKey: 'az',
  translations: azTranslations,
}
